import { render, staticRenderFns } from "./TeaserServiceOverview.vue?vue&type=template&id=847eaf90"
import script from "./TeaserServiceOverview.vue?vue&type=script&lang=ts"
export * from "./TeaserServiceOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports